module.exports = __webpack_public_path__ + "img/cc.0f3b944a.svg";